<template>
  <Dialog
    title="新增"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form label-width="120px" :model="form" :rules="rules" ref="formRef">
      <el-form-item label="职业名称：">
        <el-input
          v-model.trim="form.trainName"
          auto-complete="off"
          placeholder="请输入名称"
        >
        </el-input>
      </el-form-item>
      <el-form-item width="100%">
        <el-button plain round size="small" @click="handleClose"
          >关闭</el-button
        >
        <el-button plain round size="small"
          type="primary"
          :loading="submitLoading"
          @click="submitForm"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </Dialog>
</template>

<script>
const defaultForm = () => ({
  categoryIdOne: "",
  categoryIdTwo: "",
  courseCode: "",
  courseId: "",
  courseImage: "",
  courseIntroduce: "",
  courseName: "",
  coursePrice: "",
  courseTime: "",
  createTime: "",
  delFlag: "",
  endTime: "",
  params: "",
  saleCount: "",
  startTime: "",
  status: "",
  teacherCode: "",
  trainName: ""
});

export default {
  data() {
    return {
      dialogVisible: false,
      form: defaultForm(),
      rules: {},
      submitLoading: false
    };
  },
  methods: {
    open() {
      this.form = defaultForm();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      try {
        // this.AddSchool(this.form)
      } finally {
        this.submitLoading = false;
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = defaultForm();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Course/CourseAddDialog.vue